/**
 * ManageGroup Page Wrapper
 * Handles routing and navigation for group management operations
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ManageGroup from './ManageGroup';

export const ManageGroupWrapper: React.FC = () => {
  const { operation, id } = useParams<{ operation: string; id?: string }>();
  const navigate = useNavigate();

  // Parse operation type and ID
  const operationType = operation?.toLowerCase();
  const groupId = id ? parseInt(id, 10) : undefined;

  // Validate operation type
  const validOperations = ['create', 'duplicate', 'edit'];
  if (!operationType || !validOperations.includes(operationType)) {
    // Invalid operation, redirect to dashboard
    navigate('/dashboard');
    return null;
  }

  // Handle back navigation - return to dashboard
  const handleBack = () => {
    navigate('/dashboard');
  };

  // Handle success - return to dashboard and refresh
  const handleSuccess = () => {
    navigate('/dashboard');
  };

  // Determine props based on operation type
  const getManageGroupProps = () => {
    const baseProps = {
      onBack: handleBack,
      onSuccess: handleSuccess,
    };

    switch (operationType) {
      case 'create':
        return baseProps;
      
      case 'duplicate':
        if (!groupId) {
          navigate('/dashboard');
          return null;
        }
        return {
          ...baseProps,
          duplicateGroupId: groupId,
        };
      
      case 'edit':
        if (!groupId) {
          navigate('/dashboard');
          return null;
        }
        return {
          ...baseProps,
          editGroupId: groupId,
        };
      
      default:
        return baseProps;
    }
  };

  const manageGroupProps = getManageGroupProps();
  
  if (!manageGroupProps) {
    return null;
  }

  return (
    <ManageGroup {...manageGroupProps} />
  );
};

export default ManageGroupWrapper;